const ALLOWED_CHARACTERS_REG = /[А-Яа-я0-9,?+!@"#№;$%^&*()=]/gi;

export const allowedCharacters = (
  ev: any, callback: (val: string) => void) => {
  return ev?.target?.value?.search(ALLOWED_CHARACTERS_REG) === -1 && callback(ev.target.value)
}const ALLOWED_CHARACTERS_REG = /[А-Яа-я0-9,?+!@"#№;$%^&*()=]/gi;

export const allowedCharacters = (
  ev: any, callback: (val: string) => void) => {
  return ev?.target?.value?.search(ALLOWED_CHARACTERS_REG) === -1 && callback(ev.target.value)
}